import { render } from "./HomeBaseCollectionReceipts.vue?vue&type=template&id=59c3d520"
import script from "./HomeBaseCollectionReceipts.vue?vue&type=script&lang=js"
export * from "./HomeBaseCollectionReceipts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__